import React, { useState } from "react";
import model_mining_logo3 from "../assets/model_mining_logo.jpg";
import model_mining_logo_2 from "../assets/model_mining_logo_2.jpg";
import model_mining_main_logo from "../assets/LogoCompleto.png"
import model_mining_background from "../assets/background_imagen_login.jpeg";
import { authLogin } from "../services/authLogin";
import { useNavigate } from "react-router-dom";

const Login_Simplefms = () => {
  const [usernameLogin, setUserLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [isAuth, setIsAuth] = useState(true);
  const navigate = useNavigate();

  const sign_in_action = async () => {
    //console.log(usernameLogin);
    //console.log(passwordLogin);
    var data_login = await authLogin(usernameLogin, passwordLogin);
    //console.log(data_login);
    if (data_login) {
      var is_auth_response = data_login.is_auth;
      var is_more_than_one_app = data_login.is_more_than_one_app;
      setIsAuth(is_auth_response);
      if (is_more_than_one_app) {
        //console.log("Se Abre ventana para seleccionar aplicacion");
        localStorage.setItem("token_jwt", data_login.token);
        navigate("/select_app", { state: { data: data_login }, replace: true });
      }
      if (is_auth_response && !is_more_than_one_app) {
        //console.log("Se abre menu principal");
        localStorage.setItem("token_jwt", data_login.token);
        const data_login_info = data_login.user_info;
        const app_selected = {
          value: data_login_info.application_info.application_id,
          label: data_login_info.application_info.application_name,
        };
        const data_by_app = {
          user_id: data_login_info.user_id,
          user_name: data_login_info.user_name,
          user_rol: data_login_info.user_rol,
          application_info: data_login_info.application_info,
          application_menu: data_login_info.application_menu,
          application_sub_menu: data_login_info.application_sub_menu,
          application_selected: app_selected,
          application_list: [app_selected],
        };
        navigate("/main_app", { state: { data: data_by_app }, replace: true });
      }
    }
  };
  const handleUserName = (event) => {
    setUserLogin(event.target.value);
  };
  const handleUserPassword = (event) => {
    setPasswordLogin(event.target.value);
  };

  return (
    <div class="justify-center px-6 py-12 bg-slate-200 h-screen">
      <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm bg-white p-6">
        <div class="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            class="mx-auto h-25 w-auto "
            src={model_mining_main_logo}
            alt="Model Mining"
          />
          <h2 class="mt-10 text-center font-bold">Sign in to your account</h2>
        </div>
        <div>
          <label for="email" class="block text-sm/6 font-medium text-gray-900">
            User Name
          </label>
          <div class="mt-2 mb-4">
            <input
              type="email"
              name="email"
              id="email"
              onChange={handleUserName}
              class="block w-full border-2 border-solid rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
          </div>
        </div>

        <div>
          <div class="flex items-center justify-between">
            <label class="block text-sm/6 font-medium text-gray-900">
              Password
            </label>
          </div>
          <div class="mt-2 mb-4">
            <input
              type="password"
              name="password"
              id="password"
              autocomplete="current-password"
              onChange={handleUserPassword}
              class="block w-full border-2 border-solid rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
          </div>
        </div>

        <div>
          <button
            class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={sign_in_action}
          >
            Sign in
          </button>
        </div>
        {isAuth == false ? (
          <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <p class="mt-10 text-center bg-red-100">
              User or password is wrong
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Login_Simplefms;
